module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABXklEQVRYR82XMW7DMAxFSaDXSG9g+RoZsxRdOmfsYTp2zhJ0ydhrWL5Bc40ADFjIjeKaEinLSTwZscL/RJHfJsKdL2R959waAD75noje+74/LMHVNM0GET9C7K33/nsA+AGAVXhwQsS3ruv2NSHatn0loh0APIW4R+/98xQAP68KMSHOGheAkJqviK4ahCB+IqIXPurfDPAlLZxzHJqYfwC1ITTirHkFUAtCKz4JMBfCIi4ClEJYxZMAVogS8SyAFqJUXAWQgwj2HTucyUP+dYFkv9Iuw/rBXk3i6gxkzCpmNlu4OgMKCLO4OQOJejCnftiQKQNCHdzmCO5ahKk+X7wNNSajWSO1d7IGLIEta2MYEaAkYMl/JgFKAmV8QvSIx/ogmbPzcZFpYz3GR6mWVmql1O+52LjkTJArTJ4N0DkXj2XFL5VcdqTpaAxQ9ErNiScycWSAm0zGA8R4Qj4DSmDMsYeTvIIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pay-cclose2x.png
// module id = KvVh
// module chunks = 1